const API_BASE = '/api';

async function request(path, options = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
}

export const api = {
  // Parties
  createParty: (party_id, host_name) =>
    request('/parties', {
      method: 'POST',
      body: JSON.stringify({ party_id, host_name }),
    }),

  getParty: (party_id) =>
    request(`/parties?party_id=${encodeURIComponent(party_id)}`),

  updateParty: (party_id, fields) =>
    request('/parties', {
      method: 'PATCH',
      body: JSON.stringify({ party_id, ...fields }),
    }),

  // Submissions
  getSubmissions: (party_id) =>
    request(`/submissions?party_id=${encodeURIComponent(party_id)}`),

  getSubmissionByName: (party_id, name) =>
    request(`/submissions?party_id=${encodeURIComponent(party_id)}&name=${encodeURIComponent(name)}`),

  createSubmission: (party_id, name, movie_id) =>
    request('/submissions', {
      method: 'POST',
      body: JSON.stringify({ party_id, name, movie_id }),
    }),

  // Emails
  submitEmail: (email) =>
    request('/emails', {
      method: 'POST',
      body: JSON.stringify({ email }),
    }),

  // Feedback
  submitFeedback: (feedback) =>
    request('/feedback', {
      method: 'POST',
      body: JSON.stringify({ feedback }),
    }),
};
